import { FC, useState } from 'react';

import Bugsnag from '@bugsnag/browser';
import { IconDownload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button, LoadingIndicator } from '@cfa/react-core';

interface GetPdfButtonProps {
  pdfSrc: string;
}

const GetPdfButton: FC<GetPdfButtonProps> = ({ pdfSrc }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handlePress = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(pdfSrc, { credentials: 'include' });
      const blob = await res.blob();
      const url = URL.createObjectURL(
        new Blob([blob], { type: 'application/pdf' }),
      );
      window.open(url, '_blank');
    } catch (error) {
      Bugsnag.notify(new Error('Error getting PDF', { cause: error }));
      console.error('Error getting PDF:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      color="secondary"
      className="w-fit min-w-[200px]!"
      isDisabled={isLoading}
      onPress={handlePress}
    >
      {isLoading ? <LoadingIndicator size="sm" /> : <IconDownload />}
      {t('Button.getPdf')}
    </Button>
  );
};

export default GetPdfButton;
